// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Kopie aus kraftbogen/frontend/src/lib/pb.ts
import PocketBase from "pocketbase"

// Dev: Vite proxied /api + /_ → localhost:8092. Prod: nginx, same origin.
export const pb = new PocketBase(window.location.origin)
